<template>
<v-autocomplete v-model="model" :items="items" :loading="loading" :search-input.sync="search" :placeholder="placeholder" :hint="hint" :hide-details="hideDetails" item-value="slug" item-text="name" :menu-props="{transition:'scale-transition'}"
    persistent-hint clearable flat solo return-object no-filter :label="label">
    <template v-slot:selection="data">
        {{ data.item.name }}
    </template>
    <template v-slot:item="data">
        <v-list-item-avatar>
            <v-avatar class="elevation-4" size="36" :style="{background: data.item.color}"></v-avatar>
        </v-list-item-avatar>
        <v-list-item-content>
            <v-list-item-title v-html="data.item.name"></v-list-item-title>
            <v-list-item-subtitle v-html="data.item.slug"></v-list-item-subtitle>
        </v-list-item-content>
    </template>
</v-autocomplete>
</template>

<script>
export default {
    name: "IMSearchServices",

    props: {
        service: Object,
        service_id: [String, Number],
        service_slug: String,
        placeholder: String,
        hint: String,
        hideDetails: Boolean,
        label: {
            type: String,
            default: "Search service to add ..."
        }
    },

    data() {
        return {
            model: {
                id: null,
                name: null,
                slug: null,
                color: null,
                description: null
            },
            // flag
            loading: false,

            // search
            search: null,
            search_fields: ["slug", "name"],
            search_timeout: 500,

            // models
            items: []
        };
    },

    watch: {
        search(val) {
            if(this.model && val === this.model.name) {
                return;
            }
            clearTimeout(this.search_timeout);
            this.search_timeout = setTimeout(this.getItems(val), 300);
        },

        model() {
            this.$emit('input', this.model);
        },
        service(val) {
            this.model = {
                id: val.id,
                name: val.name,
                slug: val.slug,
                color: val.color,
            };
            if(val.id && val.name && val.slug) {
                this.items = [this.model]
            } else {
                this.items = [];
            }
        },
        service_id(val) {
            if(!val) {
                return
            }
            this.model.id = val;
            if(val) {
                this.items = [this.model]
            } else {
                this.items = [];
            }
        },
        service_slug(val) {
            if(!val) {
                return
            }
            this.getItems(val);
            this.model.slug = val;
            if(val) {
                this.items = [this.model]
            } else {
                this.items = [];
            }
        },
    },

    methods: {
        getItems(val) {
            // quit early if no search value
            if(!val) {
                return
            }
            // loading
            this.loading = true;

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/roles/services";

            // setup query params
            let params = {
                params: {
                    search: val,
                    fields: this.search_fields,
                    size: 5
                }
            };

            this.$axios.get(endpoint, params)
                .then(response => {
                    this.items = response.data.data;
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        clear() {
            this.model = {};
            this.items = [];
        }
    }
};
</script>
